/**
 * MallOS marka işareti.
 *
 * Stilize edilmiş bir AVM silueti (çatı hatları + giriş). Renk `currentColor`
 * yerine token'dan geldiği için tema seçicideki renk değişimini takip eder.
 */
export function BrandMark({ className, size }: { className?: string; size?: number }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 32 32"
      role="img"
      aria-label="MallOS"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="7" fill="rgb(var(--primary-rgb))" />
      <path
        d="M7 22V13.5L11.5 10l4.5 3.5L20.5 10 25 13.5V22h-3.5v-6.2l-1-.8-4.5 3.5-4.5-3.5-1 .8V22z"
        fill="#fff"
      />
    </svg>
  );
}
